import { render } from "./Cookies.vue?vue&type=template&id=8ae9a80c&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=8ae9a80c&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=8ae9a80c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3987448378/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ae9a80c"]])

export default __exports__